import store from "store/store";

import { PICKLIST_TYPE } from "globals/constants";


export const picklistsSelectors = {
	picklists: (state = store.getState()) => state.picklists,
	organizations: (state = store.getState()) => state.picklists[PICKLIST_TYPE.ORGANIZATIONS],
	units: (state = store.getState()) => state.picklists[PICKLIST_TYPE.UNITS],
	adHocTeams: (state = store.getState()) => state.picklists[PICKLIST_TYPE.AD_HOC_TEAMS],
	researchTeamRoles: (state = store.getState()) => state.picklists[PICKLIST_TYPE.RESEARCH_TEAM_ROLES],
};
